// Styles shared between NativeDropdown and CustomDropdown
const dropdownStyles = theme => ({
  '.dropdown': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: 'none',
    borderRadius: '4px',
    boxShadow: `0px 0px 0px 1px ${theme('colors.grey.25')}`,
    backgroundColor: theme('colors.grey.10'),
    color: theme('colors.black'),
    padding: '10px',
    cursor: 'pointer',

    '&:focus, &:focus-within': {
      boxShadow: `0px 0px 0px 2px ${theme('colors.grey.40')}`,
    },

    '&.dropdown-invalid': {
      backgroundColor: theme('colors.alertred.10'),
      color: theme('colors.alertred.60'),
      boxShadow: `0px 0px 0px 1px ${theme('colors.alertred.60')}`,

      '&:focus, &:focus-within': {
        boxShadow: `0px 0px 0px 2px ${theme('colors.alertred.60')}`,
      },
    },
  },

  '.dropdown-select': {
    appearance: 'none',
    width: '100%',
    border: 'none',
    background: 'transparent',
    outline: 'none',
    cursor: 'pointer',
    textAlign: 'left',

    '&:disabled': {
      cursor: 'not-allowed',
    },
  },

  '.dropdown-options': {
    transition: 'opacity 100ms ease-in, visibility 100ms ease-in',
  },
});

module.exports = { dropdownStyles };
